import {
    renderAccount,
    renderAircraft,
    renderAirportDirectory,
    renderDispatch,
    renderOrg,
} from 'ff/common/components/FFMenuV2/MenuItems';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/FFMenu';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';

export default function RenderFliteMenu({ currentUser }: RenderMenuParams) {
    const { flitebrief } = currentUser;

    const toReturn = [renderDispatch];

    if (flitebrief) {
        toReturn.push(...[renderAircraft, renderAirportDirectory]);
    }

    return [
        ...toReturn,
        renderOrg,
        fillSpace.bind(null, { flex: '1' }),
        renderAccount,
    ];
}
